import { useCageController_LiceTypes, useCageController_LocationTypes } from '@/services/hooks';
import type { LiceType, LocationTypeInfo } from '@/services/types';

import { type DomainQuery, useMappedQuery } from '../shared/query';

function list<T>(rows: T[]): T[] {
    return rows;
}

/** The lice types a location can count. */
export function useGetLiceTypes(): DomainQuery<LiceType[]> {
    return useMappedQuery(useCageController_LiceTypes(), list<LiceType>);
}

/** The kinds of location (sea, smolt, land based). */
export function useGetLocationTypes(): DomainQuery<LocationTypeInfo[]> {
    return useMappedQuery(useCageController_LocationTypes(), list<LocationTypeInfo>);
}
